var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmbedPlayer')
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/pages/embed-player/IframeEmbedPlayer.vue